import * as XLSX from "xlsx";

export const ethnicities = [
  "African",
  "Caribbean",
  "Indian",
  "Melanesian",
  "Australasian/Aboriginal",
  "Chinese",
  "Guamanian",
  "Japanese",
  "Korean",
  "Polynesian",
  "European/Anglo Saxon",
  "Latin American",
  "Arabic",
  "Vietnamese",
  "Micronesian",
  "Declined to Respond",
  "Other Hispanic",
  "US or Canadian Indian",
  "Puerto Rican",
  "Filipino",
  "Mexican",
  "Alaskan Native",
  "Cuban",
  "Other",
];

export function generateRandomId() {
  // Function to generate a random digit (0-9)
  function getRandomDigit() {
    return Math.floor(Math.random() * 10);
  }

  function getRandomDigitExceptNill() {
    return Math.floor(Math.random() * 9) + 1;
  }

  // Generate 5 random digits
  let randomDigits = `${getRandomDigitExceptNill()}`;
  for (let i = 0; i < 8; i++) {
    randomDigits += getRandomDigit();
  }

  return randomDigits;
}

export const downloadCSV = (data, name) => {
  // Check if data is an array and not empty
  if (!Array.isArray(data) || data.length === 0) {
    console.error("No data available to download.");
    return;
  }

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Dynamically get headers from the first object
  const headers = Object.keys(data[0]); // Ensure at least one object exists

  // Map the data to an array of objects based on headers
  const sheetData = data.map((item) => {
    const row = {};
    headers.forEach((header) => {
      row[header] = item[header]; // Assign values to row
    });
    return row;
  });

  // Create the worksheet from the array of objects
  const worksheet = XLSX.utils.json_to_sheet(sheetData, { header: headers });

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Catalog Price List");

  // Generate a file name
  const filename = `${name}.xlsx`; // Use .xlsx for Excel format

  // Write the workbook and trigger the download
  XLSX.writeFile(workbook, filename);
};


export function getTrackingUrl(carrierName, trackingId) {
  const lowerName = carrierName.toLowerCase();

  if (lowerName.includes("usps") || lowerName.includes("postal")) {
    return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${trackingId}`;
  }

  if (lowerName.includes("ups")) {
    return `https://www.ups.com/track?loc=en_US&tracknum=${trackingId}`;
  }

  if (lowerName.includes("fedex")) {
    return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingId}`;
  }

  if (lowerName.includes("dhl")) {
    return `https://www.dhl.com/en/express/tracking.html?AWB=${trackingId}`;
  }

  if (lowerName.includes("amazon")) {
    return `https://www.amazon.com/progress-tracker/package/${trackingId}`;
  }

  if (lowerName.includes("laser") || lowerName.includes("lasership")) {
    return `https://www.lasership.com/track/${trackingId}`;
  }

  if (lowerName.includes("ontrac")) {
    return `https://www.ontrac.com/trackingres.asp?tracking_number=${trackingId}`;
  }

  if (lowerName.includes("canpar")) {
    return `https://www.canpar.com/en/track/TrackingAction.do?locale=en&trackRef=${trackingId}`;
  }

  if (lowerName.includes("purolator")) {
    return `https://www.purolator.com/en/shipping/tracker?pin=${trackingId}`;
  }

  // fallback
  return "https://delivery.careapps.net";
}

export const reasonsForCompounding = [
  "Allergy to phenol (preservative in commercial GLP-1)",
  "Allergy or sensitivity to propylene glycol in commercial injection",
  "Allergy/intolerance to multiple excipients in all commercial GLP-1 products",
  "Severe injection-site reactions with commercial product",
  "Intolerable injection pain due to pH or preservatives in commercial drug",
  "Ultra-low starting dose required (commercial dose too high)",
  "Intermediate dosage strength needed (e.g., 0.75 mg not commercially available)",
  "Requires gradual titration with smaller increments than available commercial doses",
  "Higher dose required for efficacy beyond commercial max dose (e.g., >2.4 mg/week)",
  "Needle phobia requiring a non-injectable formulation",
  "Cannot swallow oral tablet and injections are contraindicated",
  "Bleeding disorder (anticoagulation) - non-injectable form required",
  "Severe dexterity/visual impairment - cannot use pen injectors",
  "Pediatric patient requires custom low-dose or flavored formulation",
  "Daily injection intolerable - needs extended dosing interval formulation",
  "Requires altered drug release profile for side-effect management",
  "Requires desensitization protocol with micro-dosed increments",
  "Combination therapy medically necessary (e.g., GLP-1 + B12 in single injection)",
  "All approved GLP-1 options failed (last resort compounding needed)",
  "Contraindication to a specific commercial formulation component"
];
